import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PaquetesService {
  TOKEN = localStorage.getItem('token');

  constructor( private http: HttpClient) { }
  getPaquetes(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPaquetes/");
  }

  getPaquetesCliente(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPaquetesCliente/",  {headers});
  }

  agregarPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarPaquete/", data);
  }

  editarPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarPaquete/", data);
  }

  updatePaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updatePaquete/", data);
  }

  getDetallePaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetallePaquete/", data);
  }

  agregarProductoPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarProductoPaquete/", data);
  }

  eliminarProductoPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarProductoPaquete/", data);
  }

  activarPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/activarPaquete/", data);
  }

  desactivarPaquete(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/desactivarPaquete/", data);
  }

  getCategorias(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getCategorias/",  {headers});
  }

  getTiposPaquete(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getTiposPaquete/",  {headers});
  }

  getPaquetesClienteV2(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getPaquetesClienteV2/",  {headers});
  }

  getFamiliasClienteV2(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/familias-cliente-v2/",  {headers});
  }

  getPaquetesFamiliaClienteV2(familia: number): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+`/api/paquetes-familia-cliente-v2/?familia=${familia}`,  {headers});
  }


  getContenido(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getContenido/",  {headers});
  }

  actualizarVideo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/actualizarVideo/", data);
  }

  actualizarVideoRegistro(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/actualizarVideoRegistro/", data);
  }


  agregarCategoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarCategoria/", data);
  }

  editarCategoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarCategoria/", data);
  }

  updateCategoria(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateCategoria/", data);
  }


}
